import React from "react";
import { ContentBody } from 'areas/shared/components';
import { Box } from "fw/components";
import Search from './Search';
import CompanyInfoTab from './CompanyInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';

class ConnectToVOB extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }


    render() {
        let opts = {
            setupKey: "companySetup",
            title: "Connect to Veteran Owned Business – ",
            description: "Search for other Veteran Owned Business (VOB's)",
            enableColumnSettings: true,
            recentType: "connectToVOB",
            enableExport: false,
            showTitle: false,
            showButtons: {
                cancel: false,
                save: false
            },
            list: {
                url: API.Biz.url('/vobSetup/searchConnectVOB'),
                rowKey: "certificationId",
                columns: [
                    { key: 'vobName', name: 'Company Name', width: 220, sortable: true },
					{ key: 'dbaName', name: 'DBA Name', width: 220, sortable: true },
                    { key: 'veteranOwner', name: 'Veteran Name', width: 220, sortable: true },
                    { key: 'naicsCodes', name: 'NAICS Code', sortable: false },
                    { key: 'stateCode', name: 'State', width: 62, sortable: true },
                    { key: 'geographicMarketName', name: 'Geo Market', width: 100, sortable: true },
                    { key: 'employees', name: 'Employees', width: 97, sortable: true },
                    { key: 'sdvs', name: 'SDVS', width: 62, sortable: true },
                    { key: 'businessOwnershipName', name: 'Ownership', width: 125, sortable: true },
                ]
            },
            tabs: [
                { key: "companyInfo", title: "Company Info", comp: CompanyInfoTab }
            ]
        };

        return (
            <React.Fragment>
                <ContentBody>
                    <Box>
                        <SetupPage {...opts} Search={Search} />
                    </Box>
                </ContentBody>
            </React.Fragment >
        );
    }
}

export default ConnectToVOB;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToVOB/ConnectToVOB.js